module.exports = __webpack_public_path__ + "img/VP-Profi13-Assembly.eb59fa44.jpg";